import axios from "axios";

const state = {
  rooms: [],
};

const actions = {
  getAll: (context) => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        url: context.rootGetters.baseUrl + "mental-health/rooms",
      })
        .then((response) => {
          context.commit("ROOMS_UPDATE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  get: (context, id) => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        url: context.rootGetters.baseUrl + "mental-health/rooms/" + id,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  add: (context, payload) => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: context.rootGetters.baseUrl + "mental-health/rooms",
        data: payload,
      })
        .then((response) => {
          context.commit("ROOM_ADD", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  update: (context, payload) => {
    const roomId = payload.id;
    return new Promise((resolve, reject) => {
      axios({
        method: "PUT",
        url: context.rootGetters.baseUrl + "mental-health/rooms/" + roomId,
        data: payload,
      })
        .then((response) => {
          context.commit("ROOM_UPDATE", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delete: (context, id) => {
    return new Promise((resolve, reject) => {
      axios({
        method: "DELETE",
        url: context.rootGetters.baseUrl + "mental-health/rooms/" + id,
      })
        .then((response) => {
          context.commit("ROOM_DELETE", id);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

const mutations = {
  ROOMS_UPDATE: (state, rooms) => {
    state.rooms = rooms;
  },
  ROOM_ADD: (state, room) => {
    state.rooms.push(room);
  },
  ROOM_UPDATE: (state, room) => {
    const index = state.rooms.findIndex((s) => s.id == room.id);
    if (index > -1) {
      state.rooms[index] = room;
    }
  },
  ROOM_DELETE: (state, id) => {
    const index = state.rooms.findIndex((s) => s.id == id);
    if (index > -1) {
      state.rooms.splice(index, 1);
    }
  },
};

const getters = {
  rooms: (state) => state.rooms,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
